import { Button, VisuallyHidden } from '@chakra-ui/react';
import { useShoppingCart } from 'context/shoppingCartContext';
import { FormattedMessage } from 'react-intl';

import { TrashIcon } from '@/components/Icons';

import { Product } from '@/models/api';
import { ProductIdProps } from '@/models/props/ShoppingCartContextProps';

type RemoveItemProps = {
    isDisabled?: boolean;
} & Pick<Product, 'code'>;

function RemoveItem({ code, isDisabled }: RemoveItemProps) {
    const { removeFromCart } = useShoppingCart();
    const removeItemHandler = (code: ProductIdProps) => {
        removeFromCart(code);
    };

    return (
        <Button
            variant="ghost"
            p={2}
            h={8}
            w={8}
            minW="0"
            isDisabled={isDisabled}
            onClick={() => removeItemHandler(code)}
        >
            <TrashIcon pointerEvents="none" fill="black" />
            <VisuallyHidden>
                <FormattedMessage id="remove-product-from-basket" />
            </VisuallyHidden>
        </Button>
    );
}

export default RemoveItem;
